/**
 * A custom-fields key a Reserve with Google booking stores on its party (googleUserId,
 * googleServiceId, ...): Google's booking data, not a field the location configured.
 */
export function isGoogleBookingField(key: string): boolean {
  return key.startsWith('google');
}
